import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import app from './modules/app'
import certificate from './modules/certificate'
import contractdetector from './modules/contractdetector'
import excellent from './modules/excellent'
import oracleManagement from './modules/oracleManagement'

import expansionDemo from './modules/expansionDemo'

import node from './modules/node'
import home from './modules/home'
import chain from './modules/blockchain'
import system from './modules/system'
import camanage from './modules/camanage'
import crosschain from './modules/crosschain'
import crossChainRecord from './modules/crossChainRecord'
import spvlightnodes from './modules/spvlightnodes'
import computing from './modules/computing'

import getters from './getters'
const userInfoStr = localStorage.getItem('cbaas_system_userInfo')
const userInfo = userInfoStr ? JSON.parse(userInfoStr) : {}
const theme = localStorage.getItem('cbaas_system_theme')
const menusObj = localStorage.getItem('cbaas_system_menus_auth') || '{}'
const btnsObj = localStorage.getItem('cbaas_system_btns_auth') || '{}'
const allFuncsObj = localStorage.getItem('cbaas_system_all_auth') || '{}'

Vue.use(Vuex)
const storeTree = {
  modules: {
    app,
    certificate,
    excellent,
    node,
    home,
    chain,
    system,
    camanage,
    oracleManagement,
    crosschain,
    crossChainRecord,
    expansionDemo,
    contractdetector,
    spvlightnodes,
    computing
  },
  getters
}

if (process.env.NODE_ENV === 'development') {
  Object.assign(storeTree, { plugins: [createLogger()] })
}

const store = new Vuex.Store(Object.assign({}, storeTree))

store.dispatch('updateUserInfo', userInfo)
store.dispatch('updateTheme', theme)

let menus = {}
let btns = {}
let allFuncs = {}
try {
  menus = JSON.parse(menusObj)
  btns = JSON.parse(btnsObj)
  allFuncs = JSON.parse(allFuncsObj)
} catch (e) {
  console.log(e)
}
store.dispatch('updateResourceList', { menus: menus, btns: btns, allFuncs: allFuncs })

export default store
